import { SpaOutlineIcon } from './SpaOutlineIcon';

/**
 * author: Google
 * id B0D344FE-8924-48EF-BFBA-93DB1C77DFD1
 * name spa-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/spa-outline.svg
 * tags
 * - Nature 
 */
export const FlowerLotusOutlineIcon = SpaOutlineIcon;
export default FlowerLotusOutlineIcon